// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import { Keyboard } from 'swiper/modules';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/scrollbar';
import 'swiper/css/pagination';
import useGetData from '../../hook/getData';
import { GetBlogCategories, GetBlogs, GetlatestBlog } from '../../services/client/blog/getBlogCategories';
import CategoryBlog from '../../components/category/blogCategory';
import { BlogsSettings, ProductBlogSettings } from '../../features/swiperOptions/swiperOptions';
import { GetProducts } from '../../services/client/products/getProducts';
import { useEffect, useMemo } from 'react';
import NewProducts from '../../components/newProduct/newProducts';
import { Link } from 'react-router';
import { IconChevronLeft } from '@tabler/icons-react';

const shuffleArray = <T,>(array: T[]): T[] => {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
};


const Blog = () => {
    const { data: categoiresBlog } = useGetData(['categories-blog'], GetBlogCategories)
    const { data: latestBlog } = useGetData(['latest-blog'], GetlatestBlog)
    const { data: blogs } = useGetData(['blogs'], GetBlogs)
    const { data: Products } = useGetData(['products'], GetProducts)
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])
    const shuffledDiscountProducts = useMemo(() => {
        return Products?.latestProducts
            ? shuffleArray(Products.latestProducts)
            : [];
    }, [Products?.latestProducts]);
    return (
        <>
            <section id="category" className='my-md-3 my-5 mb-3 container'>
                <Swiper
                    slidesPerView={7}
                    centeredSlides={false}
                    slidesPerGroupSkip={1}
                    spaceBetween={0}
                    grabCursor={true}
                    keyboard={{
                        enabled: true,
                    }}
                    breakpoints={{
                        176: {
                            slidesPerView: 3,
                        },
                        768: {
                            slidesPerView: 7,
                        },
                        1000: {
                            slidesPerView: 9,
                        },
                    }}
                    navigation={true}
                    pagination={{
                        clickable: true,
                    }}
                    modules={[Keyboard]}
                    className="mySwiper"
                >
                    {categoiresBlog
                        ?.categories.map((category: any) => (
                            <SwiperSlide key={category.id + 'category'}>
                                <CategoryBlog
                                    slug={category.slug}
                                    icon={category.image}
                                    name={category.name}
                                />
                            </SwiperSlide>
                        ))}
                </Swiper>
            </section>

            {latestBlog?.data && (
                <section id='lastBlog' className='my-3 mt-4 container'>
                    <h6 className='card-mb-3 fw-bold h5'>آخرین مطالب</h6>
                    <div className='row gy-3 mt-4'>
                        <div className='col-md-5'>
                            {latestBlog.data[0] && (
                                <Link className='text-decoration-none' to={`/blog/detail/${latestBlog.data[0].slug}`}>
                                    <div className='card border-0 rounded rounded-4 blog-card' style={{ backgroundImage: `url(https://dash.arascome.com/uploads/files/blog/posts/${latestBlog.data[0].image})` }}>
                                        <div className='d-flex h-100 align-items-end'>
                                            <div className='linear-gradiant-blog'>
                                                <div className='card-body'>
                                                    {latestBlog.data[0].title}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Link>

                            )}
                        </div>
                        <div className='col-md-7'>
                            <div className='row blog-items g-3'>
                                {latestBlog?.data?.map((item: any, index: number) => (
                                    <>
                                        {index > 0 && index < 5 && (
                                            <div className='col-md-6'>
                                                <Link className='text-decoration-none' to={`/blog/detail/${item.slug}`}>
                                                    <div className='card border-0 rounded rounded-4 blog-card' style={{ backgroundImage: `url(https://dash.arascome.com/uploads/files/blog/posts/${item.image})` }}>
                                                        <div className='d-flex h-100 align-items-end'>
                                                            <div className='linear-gradiant-blog'>
                                                                <div className='card-body'>
                                                                    {item.title}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </div>
                                        )}
                                    </>

                                ))}
                            </div>
                        </div>
                    </div>
                </section>
            )}

            <section className="bg-white py-3 pb-3">
                <div className="container">
                    <div className="d-flex justify-content-between mb-3 align-items-center">
                        <h6 className="fw-bold h5 mb-0">پیشنهاد سردبیر</h6>
                    </div>
                    <div className="new-products">
                        {blogs?.posts ? (
                            <Swiper
                                {...BlogsSettings}
                            >
                                {blogs?.posts?.data?.map((blog: any) => (
                                    <>
                                        {blog.is_featured !== 0 && (
                                            <SwiperSlide key={blog.id + 'blogs'}>
                                                <Link className='text-decoration-none' to={`/blog/detail/${blog.slug}`}>
                                                    <div className='card rounded rounded-4 border-0 shadow-sm card-body blog-item-card'>
                                                        <div className='card-image'>
                                                            <img src={`https://dash.arascome.com/uploads/files/blog/posts/${blog.image}`} alt="" />
                                                        </div>
                                                        <div className='card-items mt-3'>
                                                            <div className='blog-toggle'>
                                                                {blog?.categories[0]?.name}
                                                            </div>
                                                            <h6 className='fw-bold text-black line-25 text-split font-medium-lg mt-3'>
                                                                {blog.title}
                                                            </h6>
                                                            <div className='d-flex justify-content-between mt-3'>
                                                                <p className='text-muted font-medium mb-0'>
                                                                    ادمین ارس کام
                                                                </p>
                                                                <span className='font-medium text-muted'>اردیبهشت 1405</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </SwiperSlide>
                                        )}
                                    </>

                                ))}
                            </Swiper>
                        ) : null}
                    </div>
                </div>
            </section>

            <section className="bg-white py-3 pb-3">
                <div className="container">
                    <div className="d-flex justify-content-between mb-3 align-items-center">
                        <h6 className="fw-bold h5 mb-0">وبلاگ ها</h6>
                        <Link className='font-medium-lg text-site text-decoration-none' to='/blog/categories/all'>مشاهده همه <IconChevronLeft size={16} /></Link>
                    </div>
                    <div className="new-products">
                        {blogs?.posts ? (
                            <Swiper
                                {...BlogsSettings}
                            >
                                {blogs?.posts?.data?.reverse().map((blog: any) => (
                                    <>
                                        <SwiperSlide key={blog.id + 'blogs'}>
                                            <Link className='text-decoration-none' to={`/blog/detail/${blog.slug}`}>
                                                <div className='card rounded rounded-4 border-0 shadow-sm card-body blog-item-card'>
                                                    <div className='card-image'>
                                                        <img src={`https://dash.arascome.com/uploads/files/blog/posts/${blog.image}`} alt="" />
                                                    </div>
                                                    <div className='card-items mt-3'>
                                                        <div className='blog-toggle'>
                                                            {blog?.categories[0]?.name}
                                                        </div>
                                                        <h6 className='fw-bold text-black line-25 text-split font-medium-lg mt-3'>
                                                            {blog.title}
                                                        </h6>
                                                        <div className='d-flex justify-content-between mt-3'>
                                                            <p className='text-muted font-medium mb-0'>
                                                                ادمین ارس کام
                                                            </p>
                                                            <span className='font-medium text-muted'>اردیبهشت 1405</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Link>
                                        </SwiperSlide>
                                    </>

                                ))}
                            </Swiper>
                        ) : null}
                    </div>
                </div>
            </section>

        </>
    )
}

export default Blog;